import { jsx as _jsx } from "react/jsx-runtime";
import { KANBAN_COL_GUTTER, KANBAN_COL_LIST_SPACER, KANBAN_COL_WIDTH } from "~/components/KanbanView/shared/kanbanConstants";
const horizontalPadding = KANBAN_COL_LIST_SPACER + KANBAN_COL_GUTTER / 2;
export const KanbanFakeGroup = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "grid h-full grid-cols-5 gap-[18px] overflow-hidden",
        style: {
            gridTemplateColumns: "repeat(5, ".concat(KANBAN_COL_WIDTH, "px)"),
            paddingLeft: horizontalPadding,
            paddingRight: horizontalPadding
        },
        children: children
    });
};
